import { Outlet } from '@tanstack/react-router';
import { YoutubeCMSHeader } from '@anytag/shared-organisms';
import { YoutubeCMSProvider } from './YoutubeCMSContext';

export const YoutubeCMS = () => (
  <div>
    <YoutubeCMSHeader />
    <YoutubeCMSProvider>
      <Outlet />
    </YoutubeCMSProvider>
  </div>
);
